// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  branchKey: "key_test_idMES2QU5LLDGMH6N9bXagbhvBgTPbL3",
  paymentEndPoint: "https://sandbox.juspay.in/pay-v3.js",
  // paymentEndPoint: 'https://api.juspay.in/pay-v3.js',
  trueCaller: {
    key: "TIsfpfd730ca7040948259bdf6290999c92bb",
    name: "myteam-staging",
  },
  // pinPointparam : {
  //     applicationId: "ef93af701ffc4ad09b6433ea0063ec0b",
  //     applicationName:'eve_name',
  //     config:{
  //         credentials : {
  //             accessKeyId : 'AKIARGSG5LVIQNQSH44C',
  //             secretAccessKey : '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'
  //         },
  //         apiVersion: '2016-12-01',
  //         region: "ap-south-1"
  //     }
  // },
  pinPointparam: {
    applicationId: "6537f6916bc84ed984d84d1097b2d8fa",
    applicationName: "my-team11-prod",
    config: {
      credentials: {
        accessKeyId: "AKIASYSC6E4XVG3KUJCN",
        secretAccessKey: "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",
      },
      apiVersion: "2016-12-01",
      region: "ap-south-1",
    },
  },
  smartech: {
    create: "ADGMOT35CHFLVDHBJNIG50K96BILOJ1I0JO7VLAQL3Q2CB1IUEP0",
    register: "4993bc2c7d92ddead8e71852550d90c1",
    // create: 'ADGMOT35CHFLVDHBJNIG50K96BILOJ1I0JO7VLAQL3Q2CB1IUEP0',
    // register: '4993bc2c7d92ddead8e71852550d90c1',
    identify: "",
    listIdentifier: [19, 20, 24, 27, 28, 30],
  },
  clevertap: {
    apiKey: "W69-R59-R96Z",
  },
  apiUrl: "https://api.goteam11.com/",
  // apiTestUrl: "https://api.myteam11.com/",
  apiTestUrl: "https://rd.goteam11.com/",
  // apiNewUrl: "https://rd.goteam11.com/",
  // apiUrl: "https://n2.myteam11.com/",
  //  apiUrl: 'https://localhost:44328/',
  //  apiUrl: 'https://app.myteam11.net/',
  //  apiUrl:'https://n3.myteam11.net/',
  //    apiUrl:'http://localhost:53797/',
  // apiUrl: "https://redis.goteam11.com/",
  //   apiUrl: 'https://web.myteam11.com/',
  //  apiNewUrl: 'https://web.myteam11.com/',
  // apiTestUrl: "https://api.goteam11.com/",
  // apiNewUrl: "https://app.myteam11.net/",
  //apiNewUrl: "https://n2.myteam11.com/",
  apiNewUrl: "https://api.goteam11.com/",
  //apiTestUrl: 'https://app2.goteam11.com/',
  // apiNewUrl: "https://rd.goteam11.com/",
  // apiChangeUrl: "https://gameplay.myteam11.com/",
  apiChangeUrl: "https://gameplay.goteam11.com/",
  apiTdsUrl: "https://rd.goteam11.com/",
  // apiTdsUrl: "https://api.myteam11.com/",
  isHT: false,
  isSupportDomain: false,
  //    apiUrl: 'https://app.myteam11.com/',
  fbClientId: "1473386586029463",
  googleConsoleAPIkey: "AIzaSyB1w0xRo2L9ZdStmebvPBJ0D57be5J546Q",
  gmailClientId:
    "128702353294-nb3our0oc0ru389t0mcfpbkmfdmbp3bn.apps.googleusercontent.com",
  keyPair:
    "BIYe08x1jR5hKUp_r6-fKNYKCYwlz5SKI6D5kk0ywFNQ4G3I7YmH74l7Pn6b83SD57IrqtCkl3vRdkAR9sx-4Vc",
  // firebase: {
  //     apiKey: 'AIzaSyCgdTEqj-UdyQtZ3wxATRSKnwpMd4yvjOE',
  //     authDomain: 'analaticsapp.firebaseapp.com',
  //     databaseURL: 'https://analaticsapp.firebaseio.com',
  //     projectId: 'analaticsapp',
  //     storageBucket: '',
  //     messagingSenderId: '66276134244',
  //     appId: '1:66276134244:web:a9346692b4887b67ad7e71',
  //     measurementId: 'G-99BEV23CXC'
  // }
  firebase: {
    apiKey: "AIzaSyBd80hFV34ONaDe9lWdGdC1mTXoLRm0-xg",
    authDomain: "myteam11-e7ffc.firebaseapp.com",
    databaseURL: "https://myteam11-e7ffc.firebaseio.com",
    projectId: "myteam11-e7ffc",
    storageBucket: "myteam11-e7ffc.appspot.com",
    messagingSenderId: "487152729427",
    appId: "1:487152729427:web:6d1fccb24361f65ebc75a6",
    measurementId: "G-W12EHT8MTC",
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
